/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemCancelPreviewViewModel } from "../types/ExamItemCancelPreviewViewModel.ts";
import { examItemCancelPreviewExamViewModelSchema } from "./examItemCancelPreviewExamViewModelSchema.ts";

export const examItemCancelPreviewViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da questão a ser cancelada.")),
  label: z
    .string()
    .describe("Enunciado da questão (pode conter HTML). Opcional.")
    .nullish(),
  disciplineName: z
    .string()
    .describe("Nome da disciplina associada à questão. Opcional.")
    .nullish(),
  weight: z.optional(
    z.number().int().describe("Peso da questão na composição da nota final."),
  ),
  examsHasQuestion: z
    .array(z.lazy(() => examItemCancelPreviewExamViewModelSchema))
    .describe(
      "Lista de provas que contêm esta questão e serão afetadas pelo cancelamento.",
    )
    .nullish(),
}) as unknown as ToZod<ExamItemCancelPreviewViewModel>;
